module.exports = "<jujo_component specialized=\"true\" comp=\"test_env\"></jujo_component>"